export default __webpack_public_path__ + "static/media/shoppinglist@3x.cb90f37c.png";